import {  CalendarTodayOutlined, DescriptionOutlined, TimerOutlined } from '@mui/icons-material';
import {  Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import * as React from 'react';

var utc = require('dayjs/plugin/utc');

dayjs.extend(utc);
require('dayjs/locale/ar');


const AppointmentInformation = ({appointment_information}) =>{


    const {
        appointment_calendar_patient_comments:comment,
        appointment_calendar_date:appointmentDate,
        appointment_calendar_time_of_day:appointmentTime
      } = appointment_information;
   
    return (
        
            <>
                <Grid item xs={12} container  justifyContent="center" rowGap={3}>
                 <Grid item container  xs={8} columnGap={1}>
                            <TimerOutlined style={{color:'#279BFF'}}/>
                            <span dir="ltr">
                                {dayjs( appointmentTime,'HH:mm:SS').format('hh:mm a')}
                            </span>
                        </Grid>
                        <Grid item container xs={8} columnGap={1}>
                            <CalendarTodayOutlined style={{color:'#279BFF'}}/>
                            {dayjs(appointmentDate).utc().locale('ar').format('يوم dddd ,DD MMMM , YYYY')}    
                        </Grid>
                 </Grid>
                 <Grid item container xs={12} justifyContent="center" rowGap={3}>
                       {comment && <Grid item container  xs={8} columnGap={1}>
                            <Grid container gap={1}>
                            <DescriptionOutlined  style={{color:'#279BFF'}}/>  {Localization.translate['appointment_note']} :
                            </Grid>
                            <Typography variant="body2" px={5} py={1}>
                                {comment}
                            </Typography>
                        </Grid>
                        }
                </Grid>
                 </>
    );
};

export default AppointmentInformation ;